import { CheckIcon, CircleDashedIcon, WarningIcon, XIcon } from '@phosphor-icons/react';

const GLYPH = { ok: CheckIcon, warn: WarningIcon, violated: XIcon, na: CircleDashedIcon } as const;

/** O texto cru do fornecedor, frase a frase, com o estado que o BFF lhe deu.
 *  Fechado por padrão: o card e as cinco linhas são o resumo; isto é a fonte,
 *  para quem quer conferir — e para "eCredit", "milhas", "cabine", que não cabem
 *  em dimensão nenhuma e antes sumiam em silêncio.
 *
 *  Mora ao LADO do card (`.ffs-item`, em `FareFamilyCard`) e nunca dentro dele:
 *  descendente de `role="radio"` é conteúdo apresentacional — o `<summary>`
 *  sumia da árvore de acessibilidade —, e `<details>` aninhado num `<button>` é
 *  `nested-interactive`, violação séria do axe. Fora do botão a divulgação é um
 *  controle comum: foco próprio, sem `stopPropagation` próprio e sem replicar o
 *  roving do trilho — quem impede o clique de borbulhar até o toggle do
 *  `<li class="fq-row">` é o wrapper `.fq-expansion` (`onClick={stopPropagation}`
 *  em `offer_row.tsx`), não este componente. */
export function SupplierNotes({
  benefits,
  summary,
}: {
  readonly benefits?: ReadonlyArray<{ text: string; status: keyof typeof GLYPH }> | undefined;
  /** O resumo da divulgação ("Regras informadas pelo fornecedor"). */
  readonly summary: string;
}) {
  if (!benefits?.length) return null;
  return (
    <details className="ffs-notes">
      <summary>{summary}</summary>
      <ul>
        {benefits.map((b, i) => {
          const Glyph = GLYPH[b.status];
          return (
            // Índice + status, não `b.text`: duas frases cruas do fornecedor
            // podem repetir o mesmo texto (plausível no que não foi
            // classificado), e `b.text` sozinho colidiria como chave.
            <li key={`${String(i)}-${b.status}`} className={`is-${b.status}`}>
              <Glyph size={12} aria-hidden />
              {b.text}
            </li>
          );
        })}
      </ul>
    </details>
  );
}
